/**
 * 移动端rem适配方案
 * 设计稿宽度: 750px
 * 在任意屏幕宽度下，1rem = 屏幕宽度 / 10
 *
 * 例如：
 * - 750px 屏幕: 1rem = 75px  (设计稿上 75px = 1rem)
 * - 375px 屏幕: 1rem = 37.5px (设计稿上 75px = 1rem，自动缩放50%)
 * - 320px 屏幕: 1rem = 32px  (设计稿上 75px = 1rem，自动缩放42.67%)
 */

// 设计稿宽度
export const DESIGN_WIDTH = 750;

// 移动端阈值：小于等于此宽度视为移动端（包含宽屏手机和平板）
const MOBILE_WIDTH_THRESHOLD = 1024;

const setRem = () => {
  // 获取当前设备宽度
  const clientWidth = document.documentElement.clientWidth || window.innerWidth;

  // 判断是否为移动端：宽度小于等于阈值
  const isMobile = clientWidth <= MOBILE_WIDTH_THRESHOLD;

  // 只在移动端设置 fontSize
  if (isMobile) {
    // 动态计算根字体大小：屏幕宽度 / 10
    // 这样设计稿上的 75px (750/10) 就等于 1rem
    // 在任意屏幕上都能保持相同的视觉比例
    const fontSize = clientWidth / 10;
    document.documentElement.style.fontSize = fontSize + 'px';
  } else {
    // Web端重置为默认字体大小
    document.documentElement.style.fontSize = '';
  }
};

/**
 * 将设计稿px转换为rem
 * @param px 设计稿上的px值（基于750px设计稿）
 * @returns rem值
 *
 * @example
 * pxToRem(75) // 返回 '1rem' (设计稿75px)
 * pxToRem(30) // 返回 '0.4rem' (设计稿30px)
 * pxToRem(150) // 返回 '2rem' (设计稿150px)
 *
 * 在不同屏幕上的实际显示：
 * - 750px屏幕: pxToRem(75) = 1rem = 75px
 * - 375px屏幕: pxToRem(75) = 1rem = 37.5px (自动缩放50%)
 * - 320px屏幕: pxToRem(75) = 1rem = 32px (自动缩放42.67%)
 */
export const pxToRem = (px: number): string => {
  // 基准值 = 设计稿宽度 / 10
  // 例如：750px / 10 = 75，所以设计稿上的 px 值除以 75 得到 rem 值
  const baseSize = DESIGN_WIDTH / 10;
  return (px / baseSize) + 'rem';
};

// 初始化
setRem();

// 监听窗口大小变化
window.addEventListener('resize', setRem);
window.addEventListener('orientationchange', setRem);

export default setRem;
